const lookupsRequests={
    list: {
        providerFilterPlaceHolder: 'Service provider' ,
        noData:'There is no lookups requests yet',
        bulkSelection: 'Bulk Selection',
        itemsSelected:'Items Selected',
        addedByProvider:'Added by provider',
        serviceTypeFilterPlaceHolder: 'Service Type',
        multiSessions: 'Multi-Sessions',
        singleService: 'Single Service'
    },
    card: {
        acceptLabel: 'Accept',
        rejectLabel:'Reject',
        multiSessionsTag: 'Multi-Sessions'
    },
    rejectModal: {
        singleTitle:'Reject lookups request',
        bulkTitle:'Reject lookups requests',
        contentText:'Rejection reason',
        placeholder:'Enter rejection reason'
    },
};

export default lookupsRequests;